import { useQuery } from "@tanstack/react-query";
import api from "@app/services/api";
import { apiEndpoints } from "@app/utils/constants";
import type { UseQueryOptions } from "@tanstack/react-query";
import type {
  ApiError,
  BrandListParams,
  BrandListResponse,
} from "@app/services/api.types";
type QueryOptions = Omit<
  UseQueryOptions<BrandListResponse, ApiError>,
  "queryKey" | "queryFn"
>;
export const fetchBrandList = async (
  params: BrandListParams
): Promise<BrandListResponse> => {
  const url = apiEndpoints.brands.getList(params);
  const response = await api.get(url);
  return response?.data?.data;
};
const useBrands = (params: BrandListParams, options?: QueryOptions) => {
  return useQuery<BrandListResponse, ApiError>({
    queryKey: ["brand", "list", params],
    queryFn: () => fetchBrandList(params),
    ...options,
  });
};
export default useBrands;
